import {
  TContactFlagsFormKeys,
  TContactFormKeys,
  TContactRelinkingFormKeys,
} from 'clickNgo/entities/contact'

import { ContactFormMenuItems } from './models'

export const ContactEditorFormKeys = {
  common: 'cng-contact_editor-common',
  general: 'cng-contact_editor-general',
  hpRoles: 'cng-contact_editor-hp_roles',
  additional: 'cng-contact_editor-additional',
  toolAccess: 'cng-contact_editor-tool_access',
  userRights: 'cng-contact_editor-user_rights',
  campaigns: 'cng-contact_editor-campaigns',
  contactRelinking: 'cng-contact_editor-contact_relinking',
  settings: 'cng-contact_editor-settings',
  onboardingContactRelinking: 'cng-contact_editor-onboarding_contact_relinking',
} as const satisfies TContactFormKeys & TContactFlagsFormKeys & TContactRelinkingFormKeys

export type ContactEditorFormKey =
  (typeof ContactEditorFormKeys)[keyof typeof ContactEditorFormKeys]

export const contactEditorDefaultSetting = {
  currentMenuItem: ContactFormMenuItems.Basic,
  editableMenuItems: [],
  errorMessages: [],
  isReadOnly: false,
  isLoading: false,
}
